<div *ngIf="!showRequest">
  <h2 class="sectionTitle">{{'FRONT_USER.ConfirmVesselTransitForm.FormHeader' | translate }}</h2>
  <div *ngIf="baseRequestId" class="read-only-content">
    <!--request Details summary-->
    <app-transit-request [IsAdminMode]="true" #transitRequest></app-transit-request>
  </div>

  <form name="confirmVesselTransitForm" [formGroup]="confirmVesselTransitForm">
    <div class="form-container" #confirmVesselTransitControls>
      <div class="form-section">
        <h4 class="section-title">{{'FRONT_USER.ConfirmVesselTransitForm.FormHeader' | translate }}</h4>

        <div class="form-group">
          <label>{{'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.DECISION_LABEL' | translate}} <span
              class="red">*</span></label>
          <div class="form-custom-inputs">
            <div *ngFor="let opt of decisionKeys" class="custom-Radio">
              <input type="radio" [id]="opt" [value]="decision[opt]" formControlName="Decision" name="Decision"
                (change)="changeDecision(decision[opt])" />
              <label [for]="opt">{{ 'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.' + opt | translate }}</label>
            </div>
          </div>
          <div *ngIf="submitted || (f.Decision?.dirty && f.Decision?.errors)" class="red">
            <div *ngIf="f.Decision?.errors?.required">
              {{'FRONT_USER.This_Field_Is_Required' | translate}}
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="decisionValue === decision.CANCEL_VesselTRANSIT">
          <label for="Notes">{{'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.NOTES' | translate}} <span
              class="red">*</span></label>
          <textarea id="Notes" formControlName="Notes" class="form-control"></textarea>
          <div *ngIf="submitted || (f.Notes?.dirty && f.Notes?.errors)" class="red">
            <div *ngIf="f.Notes?.errors?.required">
              {{'FRONT_USER.This_Field_Is_Required' | translate}}
            </div>
          </div>
        </div>



        <div class="form-group"
        *ngIf="decisionValue === decision.CONFIRM_VesselTRANSIT">
        <label for="TransitDate">{{'SHARED.REPORTS.EBOOKING_OBJECT_EXPORTING.TransitDate'| translate}}<span
          class="red">*</span></label>

        <input #TransitDateDatepicker="bsDatepicker" bsDatepicker formControlName="TransitDate" [minDate]='null'
          [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off" id="dpTransitDate"
          class="form-control" name="TransitDate" />

        <div *ngIf="submitted ||(f.TransitDate?.dirty && f.TransitDate?.errors)" class="red">
          <div *ngIf="f.TransitDate?.errors?.required">
            {{'FRONT_USER.This_Field_Is_Required' | translate}}
          </div>
        </div>
      </div>

        <div class="form-group" *ngIf="decisionValue === decision.CONFIRM_VesselTRANSIT">
          <label for="notes">{{'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.NOTES' | translate}} <span
              class="red">*</span></label>
          <textarea id="notes" formControlName="Notes" class="form-control"></textarea>
          <div *ngIf="submitted || (f.Notes?.dirty && f.Notes?.errors)" class="red">
            <div *ngIf="f.Notes?.errors?.required">
              {{'FRONT_USER.This_Field_Is_Required' | translate}}
            </div>
          </div>
        </div>



















      </div>
    </div>
    <div class="form-group">
      <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="submit()">Submit</button>
      <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
    </div>
  </form>


  <br>
</div>
